import { FC } from 'react';

import { MarkerF as Marker } from '@react-google-maps/api';

import { RETAILS_MARKERS } from '../../constants';
import { Salon } from '../../model';
import MarkerIcon from './MarkerIcon';

type Props = {
    salon: Salon;
    onClick: (salon: Salon) => void;
    isAnimated?: boolean;
};

const SalonMarker: FC<Props> = ({ salon, onClick, isAnimated }) => (
    <Marker
        icon={{
            url: MarkerIcon,
            scaledSize: new google.maps.Size(RETAILS_MARKERS.size.small.width, RETAILS_MARKERS.size.small.height),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(RETAILS_MARKERS.size.small.width / 2, RETAILS_MARKERS.size.small.height),
        }}
        position={{ lat: salon.lat, lng: salon.lng }}
        onClick={() => onClick(salon)}
        animation={isAnimated ? google.maps.Animation.BOUNCE : null}
        title={salon.address}
    />
);

export default SalonMarker;
